export default __webpack_public_path__ + "static/media/login.bfee5c54.jpg";